import axios from 'axios';

export const HTTP = axios.create({
  
  // MAU PROD
  baseURL: `https://sfhtua.servicestools.com/`,
  //baseURL: `https://auth.datools.net/`,


  //baseURL: `https://201.168.125.94/authf`,
  //baseURL: `https://empleado.datatools.mx/authf`,
  //baseURL: `http://sinapsis2.dyndns.org/authf/`,
  //axios.defaults.baseURL="http://sfhtua.servicestools.com/";

  
  // MAU DEV
  //baseURL: `https://localhost/authf`,

})
